export const SERVICE_ENDPOINT =
  process.env.REACT_APP_SERVICE_ENDPOINT || "localhost";

export const SOCKET_URL = `wss://${SERVICE_ENDPOINT}/api/ws`;

export const API_URL = `https://${SERVICE_ENDPOINT}/api/reviews`;
